var _effectorFileName = "/builds/gmini/front-utils/src/useDebounce.ts";
import "core-js/modules/web.timers.js";
import { useCallback, useRef } from 'react';
export function useDebounce(_ref) {
  var handler = _ref.handler,
      delay = _ref.delay;
  var timerRef = useRef({
    id: null
  });
  var handle = useCallback(function () {
    if (timerRef.current.id) {
      clearTimeout(timerRef.current.id);
    }

    timerRef.current.id = setTimeout(handler, delay);
  }, [delay, handler]);
  return handle;
}